"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const theme = {
  sizeLarge: 24,
  sizeSmall: 16,
  sizeXLarge: 40,
  sizeXXLarge: 58,
  sizeXSmall: 8
};
exports.theme = theme;
//# sourceMappingURL=Icon.theme.js.map